class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
    this.setRelatedProducts();

    this.addEventListener("cart:updated", this.handleMilestoneGifts.bind(this));
    document.addEventListener(
      "cart:updated",
      this.handleMilestoneGifts.bind(this)
    );
    document.addEventListener(
      "DOMContentLoaded",
      this.handleMilestoneGifts.bind(this)
    );
  }

  async handleMilestoneGifts() {
    if (window._isAddingGift) return;
    window._isAddingGift = true;

    try {
      const milestones = Array.isArray(window.theme?.milestones)
        ? window.theme.milestones
        : [];
      if (!milestones.length) return;

      let cart;
      try {
        cart = await fetch("/cart.js").then((r) => r.json());
      } catch (e) {
        return;
      }

      const parsePriceToCents = (p) => {
        if (typeof p === "number") {
          return Math.round(p * 100);
        }
        if (typeof p === "string") {
          let s = p.trim().replace(/[^\d,.\-]/g, "");
          s = s.replace(/\.(?=\d{3}\b)/g, "");
          s = s.replace(",", ".");
          const val = parseFloat(s);
          if (!isNaN(val)) return Math.round(val * 100);
        }
        return 0;
      };

      const isMilestoneGift = (it) => {
        const v = it?.properties?._is_milestone_gift;
        return v === true || v === "true";
      };

      const calcEffectiveTotalCents = (items) => {
        return items.reduce((sum, it) => {
          if (isMilestoneGift(it)) return sum;
          const cp = it?.properties?._custom_price;
          const hasCp = cp !== undefined && cp !== null && cp !== "";
          if (hasCp) {
            const custom = parseInt(String(cp).trim(), 10) || 0;
            return sum + custom * (it.quantity || 1);
          }
          return (
            sum + (it.final_line_price || it.price * (it.quantity || 1) || 0)
          );
        }, 0);
      };

      let cartTotalCents = calcEffectiveTotalCents(cart.items);

      for (const milestone of milestones) {
        const variantId = milestone?.variant_id;
        if (!variantId) continue;

        const thresholdCents = parsePriceToCents(milestone?.valor_minimo);
        const giftItem = cart.items.find(
          (item) =>
            String(item.variant_id) === String(variantId) &&
            isMilestoneGift(item)
        );

        if (giftItem && cartTotalCents < thresholdCents) {
          await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: giftItem.key, quantity: 0 }),
          });
          cart = await fetch("/cart.js").then((r) => r.json());
          cartTotalCents = calcEffectiveTotalCents(cart.items);
        }
      }

      for (const milestone of milestones) {
        const variantId = milestone?.variant_id;
        if (!variantId) continue;

        const thresholdCents = parsePriceToCents(milestone?.valor_minimo);
        if (cartTotalCents < thresholdCents) continue;

        const giftItem = cart.items.find(
          (item) =>
            String(item.variant_id) === String(variantId) &&
            isMilestoneGift(item)
        );

        if (!giftItem) {
          let added = false;
          for (let attempt = 0; attempt < 2 && !added; attempt++) {
            try {
              const resp = await fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  items: [
                    {
                      id: variantId,
                      quantity: 1,
                      properties: { _is_milestone_gift: true, _custom_price: 0 },
                    },
                  ],
                }),
              });
              added = resp.ok;
              if (!resp.ok) {
                const err = await resp.json().catch(() => ({}));
                console.warn(
                  "[brinde] falha ao adicionar marco",
                  variantId,
                  resp.status,
                  err && err.description
                );
              }
            } catch (e) {
              console.warn("[brinde] erro de rede ao adicionar marco", variantId, e);
            }
          }
          if (added) {
            cart = await fetch("/cart.js").then((r) => r.json());
            cartTotalCents = calcEffectiveTotalCents(cart.items);
          }
        } else if (giftItem.quantity > 1) {
          await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: giftItem.key, quantity: 1 }),
          });
          cart = await fetch("/cart.js").then((r) => r.json());
          cartTotalCents = calcEffectiveTotalCents(cart.items);
        }
      }

      await this.refreshDrawer(cart);
    } finally {
      window._isAddingGift = false;
    }
  }

  async refreshDrawer(cart) {
    try {
      if (!cart) {
        cart = await fetch("/cart.js").then((r) => r.json());
      }

      const sectionUrl = "/?section_id=cart-drawer";
      const html = await fetch(sectionUrl).then((r) => r.text());

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newDrawer = doc.querySelector("#CartDrawer");
      const oldDrawer = document.querySelector("#CartDrawer");

      if (newDrawer && oldDrawer) {
        oldDrawer.replaceWith(newDrawer);
      }

      this.syncEmptyState(cart);

      document.dispatchEvent(
        new CustomEvent("cart:drawer-refreshed", { detail: cart })
      );
    } catch (e) {
      console.error("Failed to refresh drawer:", e);
    }
  }

  syncEmptyState(cart) {
    let isEmpty;
    if (cart && typeof cart.item_count === "number") {
      isEmpty = cart.item_count === 0;
    } else {
      const items = this.querySelector("cart-drawer-items");
      isEmpty = items
        ? items.classList.contains("is-empty")
        : !this.querySelector(".cart-item");
    }
    this.classList.toggle("is-empty", isEmpty);
  }

  async setRelatedProducts() {
    async function fetchRelatedProducts(productId) {
      const response = await fetch(
        `/recommendations/products.json?product_id=${productId}&intent=related`
      );
      const data = await response.json();
      const relatedProducts = data.products;

      return relatedProducts
        .filter(
          (product, index) =>
            product.available && !product.tags.includes("brinde")
        )
        .slice(0, 6);
    }

    const firstProduct = document.querySelector(
      ".cart-items .cart-item:first-child"
    );
    if (!firstProduct) {
      if (document.querySelector(".related_product_cart")) {
        document.querySelector(".related_products_cart").remove();
      }
      return;
    }

    const productId = firstProduct.getAttribute("data-product-id");
    const relatedProducts = await fetchRelatedProducts(productId);
    if (!relatedProducts.length) {
      if (document.querySelector(".related_product_cart")) {
        document.querySelector(".related_products_cart").remove();
      }
      return;
    }

    function formatPrice(price) {
      let formattedPrice = (price / 100).toFixed(2);
      formattedPrice = formattedPrice.replace(".", ",");
      return formattedPrice;
    }

    relatedProducts.map((product) => {
      const relatedProduct = document.createElement("div");
      relatedProduct.classList.add("related_product_cart__product");
      relatedProduct.innerHTML = `
        <div href="${product.url}" class="related_product_cart__product-link">
          <img src="${product.images[0]}" alt="${product.title}" class="related_product_cart__product-image">
          <div class="related_product_cart__product-info">
              <a href="${product.url}" class="related_product_cart__product-link-title related_product_cart__product-title">${product.title}</a>  
              <span class="related_product_cart__product-price" data-attr="${product.price}">
                ${window.Shopify.currency.symbol}
                ${formatPrice(product.price)}</span>
              <div class="related_product_cart__product-info">
                <product-form data-section-id="template--22295391273261__product-grid"><form method="post" action="/cart/add" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form"><input type="hidden" name="form_type" value="product">
                    <input type="hidden" name="utf8" value="✓">
                    <input type="hidden" name="id" value="${product.variants[0].id}" class="product-variant-id">
                    <button id="-submit" type="submit" name="add" class="quick-add__submit button--full-width button--secondary" aria-haspopup="dialog" aria-labelledby="-submit title-template--22295391273261__product-grid-${product.id}" aria-live="polite" data-sold-out-message="true">
                    <span>Adicionar</span>
                    <span class="sold-out-message hidden">Esgotado</span>
                    
                    
                    </button><input type="hidden" name="product-id" value="${product.id}"><input type="hidden" name="section-id" value="template--22295391273261__product-grid">
                </form></product-form>
              </div>
          </div>
        </div>
      `;

      let variants = product.variants.filter((variant) => variant.available);
      const selectVariant = document.createElement("select");
      selectVariant.name = "id";
      selectVariant.classList.add("product-variant-id-select");
      selectVariant.setAttribute("aria-label", "Selecione uma opção");
      selectVariant.setAttribute("data-variant-select", "");
      if (variants.length === 1) {
        selectVariant.style.display = "none";
      }

      variants.map((variant) => {
        if (variant.available) {
          selectVariant.innerHTML += `<option value="${variant.id}">${variant.title}</option>`;
        }
      });

      const firstVariant = variants[0];
      relatedProduct.querySelector(".product-variant-id").value =
        firstVariant.id;

      relatedProduct
        .querySelector(".related_product_cart__product-price")
        .insertAdjacentElement("afterend", selectVariant);
      document
        .querySelector(
          ".related_products_cart__desktop .related_product_cart__products"
        )
        .appendChild(relatedProduct);
      const relatedProductMobile = relatedProduct.cloneNode(true);
      document
        .querySelector(
          ".related_products_cart__mobile .related_product_cart__products"
        )
        .appendChild(relatedProductMobile);

      const selectVariantElement = relatedProduct.querySelector(
        "[data-variant-select]"
      );
      selectVariantElement.addEventListener("change", (event) => {
        const inputVariant = relatedProduct.querySelector(
          ".product-variant-id"
        );
        inputVariant.dispatchEvent(new Event("change"));
        inputVariant.setAttribute("value", event.target.value);
      });
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add("animate", "active");
      setTimeout(() => window.updateProgressBar(), 500);
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden-cart");
    document
      .querySelector("#MainContent")
      .classList.add("overflow-hidden-cart");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden-cart");
    document
      .querySelector("#MainContent")
      .classList.remove("overflow-hidden-cart");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    this.setRelatedProducts();

    setTimeout(() => {
      this.handleMilestoneGifts();
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
      
      document.dispatchEvent(new CustomEvent("cart:updated"));
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }

  async onCartUpdate() {
    await super.onCartUpdate();
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer && typeof cartDrawer.syncEmptyState === "function") {
      cartDrawer.syncEmptyState();
    }
  }
}

document.addEventListener("click", function (event) {
  const cartDrawer = document.querySelector("cart-drawer");
  if (!cartDrawer || !cartDrawer.classList.contains("active")) return;

  const drawerInner = cartDrawer.querySelector(".drawer__inner");
  const overlay = cartDrawer.querySelector("#CartDrawer-Overlay");

  if (
    drawerInner &&
    overlay &&
    !drawerInner.contains(event.target) &&
    !overlay.contains(event.target)
  ) {
    cartDrawer.close();
  }
});

customElements.define("cart-drawer-items", CartDrawerItems);
